// extracted by mini-css-extract-plugin
export default {"mainContainerStyle":"styles_mainContainerStyle__B2ZZM","mainInsideContainerStyle":"styles_mainInsideContainerStyle__STbhJ"};